<template>
  <portal
    selector="#recent-gallery-posts"
    class="gallery-dashboard-portal v-application"
  >
    <div class="v-application" style="display: block">
      <GalleryDashboardSection v-if="renderGallerDashboard" />
    </div>
  </portal>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue"
import GalleryDashboardSection from "features/gallery/dashboard/GalleryDashboardSection.vue"

export default defineComponent({
  name: "GalleryDashboardPortal",
  components: { GalleryDashboardSection },
  setup() {
    const renderGallerDashboard = ref(false)

    onMounted(() => {
      const recentGalleryPostsElement = document.querySelector(
        "#recent-gallery-posts.suus-mounting-point"
      )
      if (recentGalleryPostsElement) {
        renderGallerDashboard.value = true
      }
    })

    return { renderGallerDashboard }
  },
})
</script>

<style>
.gallery-dashboard-portal {
  background-color: transparent !important;
}
</style>
